import { useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import ApiRoutes from "routing/ApiRoutes";
import { qualifyUrl } from "util/URLUtils";
import { onError } from "util/conditional/onError";
import UserNotification from "util/UserNotification";
const INITIAL_DATA = {
  total: 0,
  streams: []
};
export const STREAMS_NO_SECURITY_ID = ["streams_without_security", "overview"];
const getStreams = () => fetch("GET", qualifyUrl(ApiRoutes.StreamsApiController.withoutSecurityDefaults().url));
const useStreams = () => {
  const { data, isLoading } = useQuery({
    queryKey: [STREAMS_NO_SECURITY_ID],
    queryFn: () => onError(getStreams(), (errorThrown) => {
      if (!(errorThrown.status === 404)) {
        UserNotification.error(`Loading streams failed with: ${errorThrown}`);
      }
    })
  });
  return {
    data: data != null ? data : INITIAL_DATA,
    isLoading
  };
};
export default useStreams;
